import React from 'react';

import './index.scss';

// import Attention from 'assets/icon_attention.svg';
import {ReactComponent as Attention}  from 'assets/icon_attention.svg';
import CrossIcon from 'components/atoms/Icon/CrossIcon';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import NextButton from 'components/atoms/Button/NextButton';

const SpModal = ({
    modalIsOpen,
    cancelButton,
    nextButton,
    onClickCloseButton,
}) => {
    if (modalIsOpen) {
        return (
            <div className="SMC-overlay" onClick={onClickCloseButton}>
                <div className="SMC-content" onClick={(e) => e.stopPropagation()}>
                    <div className="SMC-wrapper">
                        <div className="SMC-information">
                            <div className="SMC-img">
                                {/* <img className="" src={Attention} alt=""/> */}
                                <Attention />
                            </div>
                            <div className="SMC-text">
                                前のページへ戻りますか？<br/>
                                入力内容は削除されます
                            </div>
                        </div>
                        <div className="SMC-button-area">
                            <div className="SMC-next-button">
                                <NextButton label={nextButton.label} onClick={nextButton.onClick} link = {nextButton.link} valid/>
                            </div>
                            <div className="SMC-cancel-button">
                                <ClickOnlyButton label={cancelButton.label} onClick={cancelButton.onClick} color='white' valid />
                            </div>
                        </div>
                        <button className="SMC-close-button" type="button" onClick={onClickCloseButton}><CrossIcon /></button>
                    </div>
                </div>
            </div>
        );
    }
    return null;
};

export default SpModal;